import { SxProps } from '@mui/system';

const flexCenter: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const fullSize: SxProps = {
  width: '100%',
  height: '100%',
};

const absoluteCenter: SxProps = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

export { flexCenter, fullSize, absoluteCenter };
